export default __webpack_public_path__ + "static/media/SBI저축.9982fa0b.svg";